import { render, staticRenderFns } from "./Documenti.vue?vue&type=template&id=598c85ce"
import script from "./Documenti.vue?vue&type=script&lang=js"
export * from "./Documenti.vue?vue&type=script&lang=js"
import style0 from "./Documenti.vue?vue&type=style&index=0&id=598c85ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports